// extracted by mini-css-extract-plugin
module.exports = {"comp":"JK_comp__kRXsv"};